import { getCookie } from "./localStorage";
import { getStorage } from "./localStorage";

let initialAuth = {
    isAuthenticated: false,
    isAuthLoading: false,
    userData: getCookie('userData') || null
};

let initialUser = {
    isUserLoading: false,
    usersList: [],
    userDetails: null,
    userExportData: null,
    userImportData: null,
    fileImportDetailsList: [],
    fileImportTotalRecords: 0,
    isFileImportLoading: false,
    downloadingFileId: null
};

let initialNotification = {
    isNotificationLoading: false,
    notificationList: {},
    notificationDetails: null,
};

let initialCommon = {
    loading: false,
    commonLoading: false,
    roles: [],
    documentModules: [],
    communicationTypes: [],
    priorityTypes: [],
    recipientGroup: [],
    users: [],
    investors: [],
    selectedRole: getCookie('selectedRole') || null,
    showResetPasswordModal: false,
    categories: [],
    // --- Persist selectedAuthorizedUser from session storage if available ---
    selectedAuthorizedUser: getStorage('selectedAuthorizedUser') || null
};

let initialInvestor = {
    isInvestorLoading: false,
    investorsList: [],
    investorDetails: null,
    preferredBulkData: [],
    catchUpBulkData: [],
    holdCoBulkData: [],
    userEquityExportData:null
};
let initialDocumentType = {
    isDocumentTypeLoading: false,
    documentTypeList: [],
    totalRecords: 0,
    documentTypeDetails: null
};

let initialDocuments = {
    documents: [],
    documentLoading: false
}

let initialCommunication = {
    communications: [],
    communicationLoading: false
};


let initialContentManagement = {
  communicationsDataList: [],
  totalRecords: 0,
  isCommunicationCenterLoading: false,
  documentTypeDropdown: [],
};

const initialState = {
    auth: initialAuth,
    user: initialUser,
    // notification: initialNotification, // Commented out to match store configuration
    investor: initialInvestor,
    documents: initialDocuments,
    communication: initialCommunication,
    common: initialCommon,
    documentTypeReducer: initialDocumentType,
    ContentManagement: initialContentManagement, // Capitalized to match store reducer
    dataCenterAutomation: {
        isDataCenterLoading: false,
        dataCenterList: [],
        totalRecords: 0,
        dataCenterDetails: null
    },
    dashboard: {
        isDashboardLoading: false,
        dashboardData: null,
        portfolioData: null
    },
    equityType: {
        isEquityTypeLoading: false,
        equityTypeList: [],
        totalRecords: 0,
        equityTypeDetails: null
    },
    holdco: {
        isHoldCoLoading: false,
        holdCoList: [],
        totalRecords: 0,
        holdCoDetails: null
    }
};


export default initialState;